import {BaseRepository} from "src/app/infrastructure/BaseRepository";

export class StickerItemRepository extends BaseRepository {

    public canCurrentUserWriteInStickerItem(sticker, access_token?) {
        return this.resource(sticker, 'ask_write_access')
            .create({access_token})
            .then((res) => this.processResponse(res));
    }
}
